import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const {timerByWorkOrderSuccess} = isOfflineDev ? await import("../tests/fixtures/timers.js") : {};

export async function getActiveTimer(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/timers/active_timer?id=${id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getMyActiveTimers(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/timers/all'
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getMyActiveWorkOrders(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/timers/my_active_work_orders?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getTimersByWorkOrder(id, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/timers/work_order?id=${id}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return timerByWorkOrderSuccess
}

export async function createNewTimer(postRequest, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/timers/new/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({postRequest})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function resumeTimer(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/timers/id/resume?id=${id}`, {
    method: 'PUT',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function pauseTimer(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/timers/id/pause?id=${id}`, {
    method: 'PUT',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function resetTimer(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/timers/id/reset?id=${id}`, {
    method: 'PUT',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function deleteTimer(id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/timers/id/delete?id=${id}`, {
    method: 'POST',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

